module.exports = __webpack_public_path__ + "img/shape_parallelogram_checked.b6079356.png";